<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Lista de Bodegas para Tiendas</h5>
        <div class="controls-above-table">
          <div class="row justify-content-center text-center">
            <div class="col-sm-12 col-md-4 flex-wrap justify-content-center mt-3">
                <input class="form-control rounded bright w-100" placeholder="Search" v-model="currentFilter.bodega"
                  type="text" />
            </div>
            <div class="col-sm-12 col-md-4 d-flex flex-wrap justify-content-center mt-3">
              <select class="form-control rounded bright w-100" v-model="currentFilter.tienda">
                <option v-for="(c, key) in tiendas" :value="c.codigo" :key="key">
                  {{ c.nombre }}
                </option>
              </select>
            </div>
            <div class="col-12 d-flex flex-wrap justify-content-center mt-3">
              <div class="input-group-append">
                <button class="btn btn-outline-success btn-md px-3" style="border-radius: 60px" @click="filterData">
                  <i class="fa fa-search"></i>
                </button>
                <button class="btn btn-outline-success btn-md px-3" style="border-radius: 60px" type="button" v-on:click="clearFilterData">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
            <div class="col-12">
              <hr />
              <div style="text-align: right">
                <router-link 
                  class="btn btn-md btn-success" 
                  :to="{ 
                    name: 'cat-position-nuevo', 
                    params: { valueForm: 'BD', actionForm: 'add', idAntecesor: 0 } 
                  }"
                >
                  <i class="fa fa-plus"></i>
                  Asignar Bodega a Tienda
                </router-link>
                <a class href="#"></a>
                <a v-if="mostrarRefresh" class="btn btn-sm btn-info" @click="refreshData" href="#">Refresh</a>
              </div>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div >
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table">
            <thead>
              <tr>
                <th scope="col">Tienda</th>
                <th class="text-center">Bodega</th>
                <th scope="col" class="text-center">Descripción</th>
                <th scope="col" class="text-center">Estado</th>
              </tr>
            </thead>
            <tbody  v-for="current in data.results" v-bind:key="current.id">
              <tr 
                class="table_row" 
                style="transition: all .5s;" 
                v-bind:style="current == detalle
                  ? 'background: #c9d6e5;'
                  : 'background: #ffffff;'
                  " @click="OpenSlideOpt(current)"
              >
                <td scope="row" class="py-3 table_line">{{ current.tienda }}</td>
                <td scope="row" class="text-center table_line">{{ current.bodega }}</td>
                <td scope="row" class="text-center table_line">{{ current.descripcion }}</td>
                <td scope="row" class="text-center table_line">
                  <div v-if="current.estatus" class="status-pill green" data-title="Activo" data-toggle="tooltip"></div>
                  <div v-if="!current.estatus" class="status-pill red" data-title="Inactiva" data-toggle="tooltip">
                  </div>
                </td>
              </tr>
              <tr style="transition: all .5s;" v-if="detalle == current">
                <td colspan="4">
                  <div class="row py-4 px-4 justify-content-center text-center">
                    <div class="col-12 text-left">
                      <h5 class="form-header">Detalle de Bodega</h5>
                    </div>

                    <div class="col-12 flex-wrap justify-content-center">
                      <div class="input-group-append">
                        <router-link
                          v-if="current.estatus"
                          class="btn btn-md btn-info text-white" 
                          :to="{ 
                            name: 'cat-position-nuevo', 
                            params: { valueForm: 'SC', actionForm: 'add', idAntecesor: current.id } 
                          }"
                        >
                          <i class="fa fa-plus"></i>
                          Agregar Sección
                        </router-link>
                        <button class="btn btn-md btn-secondary text-white" @click="editClick(current)">
                          <i class="fa fa-edit"></i>
                          Editar Bodega
                        </button>
                      </div>
                    </div>

                    <div class="col-12">
                      <hr />
                    </div>

                    <div class="col-sm-12 col-md-4 text-center">
                      <b>Bodega</b>
                      <br/>
                      <h5 class="font-weight-bold text-success">
                        {{ current.descripcion }}
                      </h5>
                    </div>
                    <div class="col-sm-12 col-md-4 text-center">
                      <b>Tienda</b>
                      <br/>
                      <h5 class="font-weight-bold text-success">
                        {{ currentTienda.nombre }}
                      </h5>
                    </div>
                    <div class="col-sm-12 col-md-4 text-center">
                      <b>Seccion(es)</b>
                      <h5 class="font-weight-bold  text-success">
                        {{ currentSecciones.length }}
                      </h5>
                    </div>
                    <div class="col-12 mt-4">
                      <h6 class="form-header">Secciones Asignadas</h6>
                      <table class="table">
                        <thead>
                          <tr>
                            <th scope="col" class="text-center">Id</th>
                            <th scope="col" class="text-center">Sección</th>
                            <th scope="col" class="text-center">Descripción</th>
                            <th scope="col" class="text-center">Estado</th>
                          </tr>
                        </thead>
                        <tbody v-if="currentSecciones.length > 0"  v-for="(currentSEC, index) in currentSecciones" v-bind:key="index">
                          <tr 
                            class="table_row"
                            @click="openSectionDetail(currentSEC.id)"
                          >
                            <td scope="row" class="text-center py-3 table_line">{{ currentSEC.id }}</td>
                            <td scope="row" class="text-center table_line">{{ currentSEC.seccion }}</td>
                            <td scope="row" class="text-center table_line">{{ currentSEC.descripcion }}</td>
                            <td scope="row" class="text-center table_line">
                              <div v-if="currentSEC.estatus" class="status-pill green" data-title="Activo" data-toggle="tooltip"></div>
                              <div v-if="!currentSEC.estatus" class="status-pill red" data-title="Inactiva" data-toggle="tooltip">
                              </div>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-if="currentSecciones.length < 1">
                          <tr>
                            <td colspan="4">
                              <h6 class="py-4 text-muted text-center">Esta Bodega Aún No Tiene Secciónes Asignadas</h6>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div class="col-12">
                      <hr/>
                    </div>
                  </div>
                </td>
              </tr>

            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>

        <div class="row">
          <div class="col-12 d-flex justify-content-center mt-5">
            <div class="input-group-append">
              <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import TiendaBodegaService from "@/services/catalogos/TiendaBodegaService";
import TiendaService from "@/services/catalogos/TiendaService";
import BodegaSeccionService from "@/services/catalogos/BodegaSeccionService";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      detalle: "",
      mostrarRefresh: false,
      currentPage: 1,
      data: [],
      currentTienda: [],
      currentSecciones: [],
      current: [],
      currentFilter: {
        bodega: null,
        tienda: null,
      }
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  watch: {
    detalle(newValue) {
      if (newValue) {
        this.getTiendaInBodegaDetalle(newValue.tienda);
        this.getSeccionesInBodegaDetalle(newValue.id);
      }
    }
  },
  mounted() {
    this.refreshData();
    this.$store.dispatch("catalogos/tiendas", {
      quitar_paginacion: true,
    });
    if (this.$route.params.id) {
      TiendaBodegaService.getById(this.$route.params.id).then((response) => {
        this.current = response.data;
        this.current.errors = [];
        this.current.id;
      });
    }
  },
  methods: {
    /**
     * Método que setea la data de la sección en el panel inferior de
     * cada registro de la tabla, al clickear cualquiera de
     * de las bodegas en la tabla
     */
     OpenSlideOpt(det) {
      let self = this;
      if (self.detalle == det) {
        self.detalle = "";
        self.currentTienda = [];
        self.currentSecciones = [];
        return;
      }
      self.detalle = det;
    },

    /**
     * Método que obtiene la data de la tienda a la que esta asignada esa bodega
     */
    getTiendaInBodegaDetalle(tiendaID) {
      let self = this;
      TiendaService.getById(tiendaID).then((response) => {
        self.currentTienda = response.data;
      });
    },

    /**
     * Método que obtiene las secciónes asignadas de una Bodega
     */
    getSeccionesInBodegaDetalle(bodegaID) {
      let self = this;
      BodegaSeccionService.fetch({bodega: bodegaID, quitar_paginacion: true}).then((response) => {
        self.currentSecciones = response.data;
      });
    },

    /**
     * Método que nos redirige a la pagina de la sección clickeada
     */
    openSectionDetail(sectionID) {
      let self = this;
      if (event.ctrlKey) {
        
        let routeUrl = this.$router.resolve({
          name: "cat-seccion-bodega-id",
          params: { idSeccion: sectionID },
          props: { bodegaObj: this.detalle }
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cat-seccion-bodega-id",
          params: { idSeccion: sectionID },
          props: { bodegaObj: this.detalle }
        });
      }
    },

    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        ...this.currentFilter
      });
    },
    filterData() {
      this.currentPage = 1;
      this.refreshData({
        page: this.currentPage,
        ...this.currentFilter
      });
    },
    clearFilterData() {
      this.currentPage = 1;
      this.currentFilter = {
        bodega: null,
        tienda: null,
      };
      this.refreshData({
        page: this.currentPage,
        ...this.currentFilter
      });
    },
    refreshData(params) {
      let self = this;
      TiendaBodegaService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    editClick(current) {
      let self = this;
      if (event.ctrlKey) {
        let routeUrl = self.$router.resolve({
          name: "cat-position-editar",
          params: { 
            valueForm: 'BD', 
            actionForm: 'edit', 
            idCurrent: current.id
          } 
        });
        window.open(routeUrl.href, "_blank");
      } else {
        self.$router.push({
          name: "cat-position-editar",
          params: { 
            valueForm: 'BD', 
            actionForm: 'edit', 
            idCurrent: current.id
          }
        });
      }
    },
    showModalEdit() { },
  },
};
</script>
<style>
.table_row {
  background-color: #ffffff;
}
.table_row:hover {
  background-color: #e8f3ff!important;
}
.cyan_gradient_bg {
  background: #4397f7;
  background: -webkit-linear-gradient(45deg, rgb(67, 151, 247) 0%, rgba(15, 50, 89, 1) 100%);
  background: -moz-linear-gradient(45deg, rgba(67, 151, 247, 1) 0%, rgba(15, 50, 89, 1) 100%);
  background: linear-gradient(45deg, rgba(67, 151, 247, 1) 0%, rgba(15, 50, 89, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#265A96", endColorstr="#0F3259", GradientType=0);
}
.purple_gradient_bg {
  background: #5637c5;
  background: -webkit-linear-gradient(45deg, rgb(86, 55, 197) 0%, rgb(41, 22, 110) 100%);
  background: -moz-linear-gradient(45deg, rgba(86, 55, 197, 1) 0%, rgba(35, 20, 89, 1) 100%);
  background: linear-gradient(45deg, rgba(86, 55, 197, 1) 0%, rgba(35, 20, 89, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#3D2A82", endColorstr="#231459", GradientType=0);
}
.green_gradient_bg {
  background: #74c529;
  background: -webkit-linear-gradient(45deg, rgb(116, 197, 41) 0%, rgb(60, 109, 15) 100%);
  background: -moz-linear-gradient(45deg, rgba(116, 197, 41, 1) 0%, rgba(60, 109, 15, 1) 100%);
  background: linear-gradient(45deg, rgba(116, 197, 41, 1) 0%, rgba(60, 109, 15, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#C7A228", endColorstr="#756A0C", GradientType=0);
}
.orange_gradient_bg {
  background: #c78528;
  background: -webkit-linear-gradient(45deg, rgba(199, 133, 40, 1) 0%, rgba(130, 81, 8, 1) 100%);
  background: -moz-linear-gradient(45deg, rgba(199, 133, 40, 1) 0%, rgba(130, 81, 8, 1) 100%);
  background: linear-gradient(45deg, rgba(199, 133, 40, 1) 0%, rgba(130, 81, 8, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#C78528", endColorstr="#825108", GradientType=0);
}
.blue_gradient_bg {
  background: #323C58;
  background: -webkit-linear-gradient(90deg, rgba(50, 60, 88, 1) 0%, rgba(74, 93, 135, 1) 51%, rgba(87, 119, 207, 1) 100%);
  background: -moz-linear-gradient(90deg, rgba(50, 60, 88, 1) 0%, rgba(74, 93, 135, 1) 51%, rgba(87, 119, 207, 1) 100%);
  background: linear-gradient(90deg, rgba(50, 60, 88, 1) 0%, rgba(74, 93, 135, 1) 51%, rgba(87, 119, 207, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#323C58", endColorstr="#5777CF", GradientType=1);
}
.red_gradient_bg {
  background: #583232;
  background: -webkit-linear-gradient(90deg, rgba(88, 50, 50, 1) 0%, rgba(206, 87, 87, 1) 100%);
  background: -moz-linear-gradient(90deg, rgba(88, 50, 50, 1) 0%, rgba(206, 87, 87, 1) 100%);
  background: linear-gradient(90deg, rgba(88, 50, 50, 1) 0%, rgba(206, 87, 87, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#583232", endColorstr="#CE5757", GradientType=1);
}
.white_gradient_bg {
  background: #fafafa;
  background: -webkit-linear-gradient(90deg, rgba(250, 250, 250, 1) 0%, rgba(224, 224, 224, 1) 100%);
  background: -moz-linear-gradient(90deg, rgba(250, 250, 250, 1) 0%, rgba(224, 224, 224, 1) 100%);
  background: linear-gradient(90deg, rgba(250, 250, 250, 1) 0%, rgba(224, 224, 224, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#FAFAFA", endColorstr="#E0E0E0", GradientType=1);
}
.white_gradient_bg_light {
  background: #fafafa;
  background: radial-gradient(circle,rgba(255, 255, 255, 1) 0%, rgba(235, 235, 235, 1) 100%);
  border-radius: 15px;
}
.white_gradient_bg_clear_light {
  background: #fafafa;
  background: radial-gradient(circle,rgba(255, 255, 255, 1) 0%, rgba(250, 250, 250, 1) 100%);
  border-radius: 15px;
}

.shadow_inset {
  box-shadow: inset 0 0 10px 0 #0000001a !important;
  transition: all .5s!important;
}
.shadow_inset:hover {
  box-shadow: inset 0 0 10px 0 #0000005b !important;
  transition: all .5s!important;
}
.shadow_inset_sm {
  box-shadow: inset 0 0 5px 0 #00000040 !important;
  transition: all .5s!important;
}
.shadow_inset_sm:hover {
  box-shadow: inset 0 0 5px 0 #00000099 !important;
  transition: all .5s!important;
}
.shadow_inset_lg {
  box-shadow: inset 0 0 10px 0 #00000025 !important;
  transition: all .5s!important;
}
.shadow_inset_lg:hover {
  box-shadow: inset 0 0 10px 0 #00000084 !important;
  transition: all .5s!important;
}
.rounded_pill {
  border-radius: 5px 25px 5px 25px!important;
}
.noBoxes {
  margin: 0!important;
  padding: 0!important;
  border-radius: 6px;
}
.bgIcons {
  font-size: 140px;
  position: absolute; 
  right: 25px; 
  top: 80px; 
  transform: translateY(-50%); 
  opacity: 0.7; 
  filter: drop-shadow(0 0 5px rgba(0, 0, 0, 0.3)); 
  z-index: 0;
}
.table_line {
  border-bottom: 0.1px solid #eee;
}
</style>